import React from 'react';

const images = [
    '10/Aufgaben/0.png',
    '10/Aufgaben/1.png',
    '10/Grundwissen/0.jpeg',
    '10/Grundwissen/1.png',
    '10/Grundwissen/10.png',
    '10/Grundwissen/11.png',
    '10/Grundwissen/12.png',
    '10/Grundwissen/13.png',
    '10/Grundwissen/14.png',
    '10/Grundwissen/15.png',
    '10/Grundwissen/16.png',
    '10/Grundwissen/17.png',
    '10/Grundwissen/18.png',
    '10/Grundwissen/19.png',
    '10/Grundwissen/2.png',
    '10/Grundwissen/20.png',
    '10/Grundwissen/21.png',
    '10/Grundwissen/22.png',
    '10/Grundwissen/23.png',
    '10/Grundwissen/24.png',
    '10/Grundwissen/25.png',
    '10/Grundwissen/26.png',
    '10/Grundwissen/27.png',
    '10/Grundwissen/28.png',
    '10/Grundwissen/29.png',
    '10/Grundwissen/3.png',
    '10/Grundwissen/30.png',
    '10/Grundwissen/31.png',
    '10/Grundwissen/32.png',
    '10/Grundwissen/33.png',
    '10/Grundwissen/34.png',
    '10/Grundwissen/35.png',
    '10/Grundwissen/36.png',
    '10/Grundwissen/37.png',
    '10/Grundwissen/38.png',
    '10/Grundwissen/39.png',
    '10/Grundwissen/4.jpeg',
    '10/Grundwissen/40.png',
    '10/Grundwissen/41.png',
    '10/Grundwissen/42.png',
    '10/Grundwissen/43.png',
    '10/Grundwissen/44.png',
    '10/Grundwissen/45.png',
    '10/Grundwissen/46.png',
    '10/Grundwissen/47.png',
    '10/Grundwissen/48.png',
    '10/Grundwissen/49.png',
    '10/Grundwissen/5.png',
    '10/Grundwissen/6.png',
    '10/Grundwissen/7.png',
    '10/Grundwissen/8.png',
    '10/Grundwissen/9.png',
    '10/Loesungen/0.jpeg',
    '10/Loesungen/1.png',
    '10/Loesungen/10.png',
    '10/Loesungen/11.png',
    '10/Loesungen/12.png',
    '10/Loesungen/13.png',
    '10/Loesungen/14.png',
    '10/Loesungen/15.png',
    '10/Loesungen/16.png',
    '10/Loesungen/17.png',
    '10/Loesungen/18.png',
    '10/Loesungen/19.png',
    '10/Loesungen/2.png',
    '10/Loesungen/20.png',
    '10/Loesungen/21.png',
    '10/Loesungen/22.png',
    '10/Loesungen/23.png',
    '10/Loesungen/24.png',
    '10/Loesungen/25.png',
    '10/Loesungen/26.png',
    '10/Loesungen/27.png',
    '10/Loesungen/28.png',
    '10/Loesungen/29.png',
    '10/Loesungen/3.png',
    '10/Loesungen/30.png',
    '10/Loesungen/31.png',
    '10/Loesungen/32.png',
    '10/Loesungen/33.png',
    '10/Loesungen/34.png',
    '10/Loesungen/35.png',
    '10/Loesungen/36.png',
    '10/Loesungen/37.png',
    '10/Loesungen/4.png',
    '10/Loesungen/5.png',
    '10/Loesungen/6.png',
    '10/Loesungen/7.png',
    '10/Loesungen/8.png',
    '10/Loesungen/9.png',
    '5/Aufgaben/0.png',
    '5/Aufgaben/1.png',
    '5/Aufgaben/2.png',
    '5/Aufgaben/3.png',
    '5/Grundwissen/0.jpeg',
    '5/Grundwissen/1.png',
    '5/Grundwissen/10.png',
    '5/Grundwissen/11.png',
    '5/Grundwissen/12.png',
    '5/Grundwissen/13.png',
    '5/Grundwissen/14.png',
    '5/Grundwissen/15.png',
    '5/Grundwissen/16.png',
    '5/Grundwissen/17.png',
    '5/Grundwissen/18.png',
    '5/Grundwissen/19.png',
    '5/Grundwissen/2.png',
    '5/Grundwissen/20.png',
    '5/Grundwissen/21.png',
    '5/Grundwissen/22.png',
    '5/Grundwissen/23.png',
    '5/Grundwissen/24.png',
    '5/Grundwissen/25.png',
    '5/Grundwissen/26.png',
    '5/Grundwissen/27.png',
    '5/Grundwissen/28.png',
    '5/Grundwissen/29.png',
    '5/Grundwissen/3.png',
    '5/Grundwissen/30.png',
    '5/Grundwissen/31.png',
    '5/Grundwissen/32.png',
    '5/Grundwissen/33.png',
    '5/Grundwissen/34.png',
    '5/Grundwissen/35.png',
    '5/Grundwissen/36.png',
    '5/Grundwissen/37.png',
    '5/Grundwissen/38.png',
    '5/Grundwissen/39.png',
    '5/Grundwissen/4.png',
    '5/Grundwissen/40.png',
    '5/Grundwissen/41.png',
    '5/Grundwissen/42.png',
    '5/Grundwissen/43.png',
    '5/Grundwissen/44.png',
    '5/Grundwissen/45.png',
    '5/Grundwissen/5.png',
    '5/Grundwissen/6.png',
    '5/Grundwissen/7.png',
    '5/Grundwissen/8.png',
    '5/Grundwissen/9.png',
    '5/Loesungen/0.jpeg',
    '5/Loesungen/1.png',
    '5/Loesungen/2.png',
    '5/Loesungen/3.png',
    '5/Loesungen/4.png',
    '5/Loesungen/5.png',
    '6/Aufgaben/0.jpeg',
    '6/Grundwissen/0.jpeg',
    '6/Grundwissen/1.png',
    '6/Grundwissen/10.png',
    '6/Grundwissen/11.png',
    '6/Grundwissen/12.png',
    '6/Grundwissen/2.png',
    '6/Grundwissen/3.png',
    '6/Grundwissen/4.png',
    '6/Grundwissen/5.png',
    '6/Grundwissen/6.png',
    '6/Grundwissen/7.png',
    '6/Grundwissen/8.png',
    '6/Grundwissen/9.png',
    '7/Aufgaben/0.jpeg',
    '7/Aufgaben/1.png',
    '7/Aufgaben/2.png',
    '7/Aufgaben/3.png',
    '7/Aufgaben/4.png',
    '7/Aufgaben/5.png',
    '7/Grundwissen/0.jpeg',
    '7/Grundwissen/1.png',
    '7/Grundwissen/10.png',
    '7/Grundwissen/100.png',
    '7/Grundwissen/101.png',
    '7/Grundwissen/102.png',
    '7/Grundwissen/103.png',
    '7/Grundwissen/104.png',
    '7/Grundwissen/105.png',
    '7/Grundwissen/106.png',
    '7/Grundwissen/107.png',
    '7/Grundwissen/108.png',
    '7/Grundwissen/109.png',
    '7/Grundwissen/11.png',
    '7/Grundwissen/110.png',
    '7/Grundwissen/111.png',
    '7/Grundwissen/112.png',
    '7/Grundwissen/113.png',
    '7/Grundwissen/114.png',
    '7/Grundwissen/115.png',
    '7/Grundwissen/116.png',
    '7/Grundwissen/117.png',
    '7/Grundwissen/118.png',
    '7/Grundwissen/119.png',
    '7/Grundwissen/12.png',
    '7/Grundwissen/120.png',
    '7/Grundwissen/121.png',
    '7/Grundwissen/122.png',
    '7/Grundwissen/123.png',
    '7/Grundwissen/124.png',
    '7/Grundwissen/125.png',
    '7/Grundwissen/126.png',
    '7/Grundwissen/127.png',
    '7/Grundwissen/128.png',
    '7/Grundwissen/129.png',
    '7/Grundwissen/13.png',
    '7/Grundwissen/130.png',
    '7/Grundwissen/131.png',
    '7/Grundwissen/132.png',
    '7/Grundwissen/133.png',
    '7/Grundwissen/134.png',
    '7/Grundwissen/135.png',
    '7/Grundwissen/136.png',
    '7/Grundwissen/137.png',
    '7/Grundwissen/138.png',
    '7/Grundwissen/139.png',
    '7/Grundwissen/14.png',
    '7/Grundwissen/140.png',
    '7/Grundwissen/141.png',
    '7/Grundwissen/142.png',
    '7/Grundwissen/143.png',
    '7/Grundwissen/144.png',
    '7/Grundwissen/145.png',
    '7/Grundwissen/146.png',
    '7/Grundwissen/147.png',
    '7/Grundwissen/148.png',
    '7/Grundwissen/149.png',
    '7/Grundwissen/15.png',
    '7/Grundwissen/150.png',
    '7/Grundwissen/151.png',
    '7/Grundwissen/152.png',
    '7/Grundwissen/153.png',
    '7/Grundwissen/154.png',
    '7/Grundwissen/155.png',
    '7/Grundwissen/156.png',
    '7/Grundwissen/157.png',
    '7/Grundwissen/158.png',
    '7/Grundwissen/159.png',
    '7/Grundwissen/16.png',
    '7/Grundwissen/160.png',
    '7/Grundwissen/161.png',
    '7/Grundwissen/162.png',
    '7/Grundwissen/163.png',
    '7/Grundwissen/164.png',
    '7/Grundwissen/165.png',
    '7/Grundwissen/166.png',
    '7/Grundwissen/167.png',
    '7/Grundwissen/168.png',
    '7/Grundwissen/169.png',
    '7/Grundwissen/17.png',
    '7/Grundwissen/170.png',
    '7/Grundwissen/171.png',
    '7/Grundwissen/172.png',
    '7/Grundwissen/173.png',
    '7/Grundwissen/174.png',
    '7/Grundwissen/175.png',
    '7/Grundwissen/176.png',
    '7/Grundwissen/177.png',
    '7/Grundwissen/178.png',
    '7/Grundwissen/179.png',
    '7/Grundwissen/18.png',
    '7/Grundwissen/180.png',
    '7/Grundwissen/181.png',
    '7/Grundwissen/182.png',
    '7/Grundwissen/183.png',
    '7/Grundwissen/184.png',
    '7/Grundwissen/185.png',
    '7/Grundwissen/186.png',
    '7/Grundwissen/187.png',
    '7/Grundwissen/188.png',
    '7/Grundwissen/189.png',
    '7/Grundwissen/19.png',
    '7/Grundwissen/190.png',
    '7/Grundwissen/191.png',
    '7/Grundwissen/192.png',
    '7/Grundwissen/193.png',
    '7/Grundwissen/194.png',
    '7/Grundwissen/195.png',
    '7/Grundwissen/196.png',
    '7/Grundwissen/197.png',
    '7/Grundwissen/198.png',
    '7/Grundwissen/199.png',
    '7/Grundwissen/2.png',
    '7/Grundwissen/20.png',
    '7/Grundwissen/200.png',
    '7/Grundwissen/201.png',
    '7/Grundwissen/202.png',
    '7/Grundwissen/203.png',
    '7/Grundwissen/204.png',
    '7/Grundwissen/205.png',
    '7/Grundwissen/206.png',
    '7/Grundwissen/207.png',
    '7/Grundwissen/208.png',
    '7/Grundwissen/209.png',
    '7/Grundwissen/21.png',
    '7/Grundwissen/210.png',
    '7/Grundwissen/211.png',
    '7/Grundwissen/212.png',
    '7/Grundwissen/213.png',
    '7/Grundwissen/22.png',
    '7/Grundwissen/23.png',
    '7/Grundwissen/24.png',
    '7/Grundwissen/25.png',
    '7/Grundwissen/26.png',
    '7/Grundwissen/27.png',
    '7/Grundwissen/28.png',
    '7/Grundwissen/29.png',
    '7/Grundwissen/3.png',
    '7/Grundwissen/30.png',
    '7/Grundwissen/31.png',
    '7/Grundwissen/32.png',
    '7/Grundwissen/33.png',
    '7/Grundwissen/34.png',
    '7/Grundwissen/35.png',
    '7/Grundwissen/36.png',
    '7/Grundwissen/37.png',
    '7/Grundwissen/38.png',
    '7/Grundwissen/39.png',
    '7/Grundwissen/4.png',
    '7/Grundwissen/40.png',
    '7/Grundwissen/41.png',
    '7/Grundwissen/42.png',
    '7/Grundwissen/43.png',
    '7/Grundwissen/44.png',
    '7/Grundwissen/45.png',
    '7/Grundwissen/46.png',
    '7/Grundwissen/47.png',
    '7/Grundwissen/48.png',
    '7/Grundwissen/49.png',
    '7/Grundwissen/5.png',
    '7/Grundwissen/50.png',
    '7/Grundwissen/51.png',
    '7/Grundwissen/52.png',
    '7/Grundwissen/53.png',
    '7/Grundwissen/54.png',
    '7/Grundwissen/55.png',
    '7/Grundwissen/56.png',
    '7/Grundwissen/57.png',
    '7/Grundwissen/58.png',
    '7/Grundwissen/59.png',
    '7/Grundwissen/6.png',
    '7/Grundwissen/60.png',
    '7/Grundwissen/61.png',
    '7/Grundwissen/62.png',
    '7/Grundwissen/63.png',
    '7/Grundwissen/64.png',
    '7/Grundwissen/65.png',
    '7/Grundwissen/66.png',
    '7/Grundwissen/67.png',
    '7/Grundwissen/68.png',
    '7/Grundwissen/69.png',
    '7/Grundwissen/7.png',
    '7/Grundwissen/70.png',
    '7/Grundwissen/71.png',
    '7/Grundwissen/72.png',
    '7/Grundwissen/73.png',
    '7/Grundwissen/74.png',
    '7/Grundwissen/75.png',
    '7/Grundwissen/76.png',
    '7/Grundwissen/77.png',
    '7/Grundwissen/78.png',
    '7/Grundwissen/79.png',
    '7/Grundwissen/8.png',
    '7/Grundwissen/80.png',
    '7/Grundwissen/81.png',
    '7/Grundwissen/82.png',
    '7/Grundwissen/83.png',
    '7/Grundwissen/84.png',
    '7/Grundwissen/85.png',
    '7/Grundwissen/86.png',
    '7/Grundwissen/87.png',
    '7/Grundwissen/88.png',
    '7/Grundwissen/89.png',
    '7/Grundwissen/9.png',
    '7/Grundwissen/90.png',
    '7/Grundwissen/91.png',
    '7/Grundwissen/92.png',
    '7/Grundwissen/93.png',
    '7/Grundwissen/94.png',
    '7/Grundwissen/95.png',
    '7/Grundwissen/96.png',
    '7/Grundwissen/97.png',
    '7/Grundwissen/98.png',
    '7/Grundwissen/99.png',
    '7/Loesungen/0.jpeg',
    '7/Loesungen/1.png',
    '7/Loesungen/2.png',
    '7/Loesungen/3.png',
    '8/Aufgaben/0.jpeg',
    '8/Aufgaben/1.png',
    '8/Aufgaben/2.png',
    '8/Aufgaben/3.png',
    '8/Aufgaben/4.png',
    '8/Aufgaben/5.png',
    '8/Aufgaben/6.png',
    '8/Aufgaben/7.png',
    '8/Grundwissen/0.jpeg',
    '8/Grundwissen/1.png',
    '8/Grundwissen/10.png',
    '8/Grundwissen/11.png',
    '8/Grundwissen/12.png',
    '8/Grundwissen/13.png',
    '8/Grundwissen/14.png',
    '8/Grundwissen/2.png',
    '8/Grundwissen/3.png',
    '8/Grundwissen/4.png',
    '8/Grundwissen/5.png',
    '8/Grundwissen/6.png',
    '8/Grundwissen/7.png',
    '8/Grundwissen/8.png',
    '8/Grundwissen/9.png',
    '8/Loesungen/0.jpeg',
    '8/Loesungen/1.png',
    '9/Aufgaben/0.jpeg',
    '9/Aufgaben/1.png',
    '9/Aufgaben/10.png',
    '9/Aufgaben/11.png',
    '9/Aufgaben/12.png',
    '9/Aufgaben/13.png',
    '9/Aufgaben/2.png',
    '9/Aufgaben/3.png',
    '9/Aufgaben/4.png',
    '9/Aufgaben/5.png',
    '9/Aufgaben/6.png',
    '9/Aufgaben/7.png',
    '9/Aufgaben/8.png',
    '9/Aufgaben/9.png',
    '9/Grundwissen/0.png',
    '9/Grundwissen/1.png',
    '9/Grundwissen/10.png',
    '9/Grundwissen/11.png',
    '9/Grundwissen/12.png',
    '9/Grundwissen/13.png',
    '9/Grundwissen/14.png',
    '9/Grundwissen/15.png',
    '9/Grundwissen/16.png',
    '9/Grundwissen/17.png',
    '9/Grundwissen/18.png',
    '9/Grundwissen/19.png',
    '9/Grundwissen/2.png',
    '9/Grundwissen/20.png',
    '9/Grundwissen/21.png',
    '9/Grundwissen/22.png',
    '9/Grundwissen/23.png',
    '9/Grundwissen/24.png',
    '9/Grundwissen/25.png',
    '9/Grundwissen/26.png',
    '9/Grundwissen/27.png',
    '9/Grundwissen/28.png',
    '9/Grundwissen/29.png',
    '9/Grundwissen/3.png',
    '9/Grundwissen/30.png',
    '9/Grundwissen/31.png',
    '9/Grundwissen/32.png',
    '9/Grundwissen/33.png',
    '9/Grundwissen/34.png',
    '9/Grundwissen/35.png',
    '9/Grundwissen/36.png',
    '9/Grundwissen/37.png',
    '9/Grundwissen/38.png',
    '9/Grundwissen/39.png',
    '9/Grundwissen/4.png',
    '9/Grundwissen/40.png',
    '9/Grundwissen/41.png',
    '9/Grundwissen/42.png',
    '9/Grundwissen/43.png',
    '9/Grundwissen/44.png',
    '9/Grundwissen/45.png',
    '9/Grundwissen/46.png',
    '9/Grundwissen/47.png',
    '9/Grundwissen/48.png',
    '9/Grundwissen/49.png',
    '9/Grundwissen/5.png',
    '9/Grundwissen/50.png',
    '9/Grundwissen/51.png',
    '9/Grundwissen/52.png',
    '9/Grundwissen/53.png',
    '9/Grundwissen/54.png',
    '9/Grundwissen/55.png',
    '9/Grundwissen/56.png',
    '9/Grundwissen/57.png',
    '9/Grundwissen/58.png',
    '9/Grundwissen/59.png',
    '9/Grundwissen/6.png',
    '9/Grundwissen/60.png',
    '9/Grundwissen/61.png',
    '9/Grundwissen/62.png',
    '9/Grundwissen/63.png',
    '9/Grundwissen/64.png',
    '9/Grundwissen/65.png',
    '9/Grundwissen/66.png',
    '9/Grundwissen/67.png',
    '9/Grundwissen/68.png',
    '9/Grundwissen/69.png',
    '9/Grundwissen/7.png',
    '9/Grundwissen/70.png',
    '9/Grundwissen/71.png',
    '9/Grundwissen/72.png',
    '9/Grundwissen/73.png',
    '9/Grundwissen/74.png',
    '9/Grundwissen/75.png',
    '9/Grundwissen/76.png',
    '9/Grundwissen/77.png',
    '9/Grundwissen/78.png',
    '9/Grundwissen/79.png',
    '9/Grundwissen/8.png',
    '9/Grundwissen/80.png',
    '9/Grundwissen/81.png',
    '9/Grundwissen/82.png',
    '9/Grundwissen/83.png',
    '9/Grundwissen/84.png',
    '9/Grundwissen/85.png',
    '9/Grundwissen/86.png',
    '9/Grundwissen/87.png',
    '9/Grundwissen/88.png',
    '9/Grundwissen/89.png',
    '9/Grundwissen/9.png',
    '9/Grundwissen/90.png',
    '9/Grundwissen/91.png',
    '9/Grundwissen/92.png',
    '9/Grundwissen/93.png',
    '9/Grundwissen/94.png',
    '9/Grundwissen/95.png',
    '9/Grundwissen/96.png',
    '9/Grundwissen/97.png',
    '9/Grundwissen/98.png',
    '9/Loesungen/0.jpeg',
    '9/Loesungen/1.png',
    '9/Loesungen/10.png',
    '9/Loesungen/11.png',
    '9/Loesungen/12.png',
    '9/Loesungen/13.png',
    '9/Loesungen/14.png',
    '9/Loesungen/15.png',
    '9/Loesungen/16.png',
    '9/Loesungen/17.png',
    '9/Loesungen/18.png',
    '9/Loesungen/19.png',
    '9/Loesungen/2.png',
    '9/Loesungen/20.png',
    '9/Loesungen/21.png',
    '9/Loesungen/22.png',
    '9/Loesungen/23.png',
    '9/Loesungen/24.png',
    '9/Loesungen/25.png',
    '9/Loesungen/26.png',
    '9/Loesungen/27.png',
    '9/Loesungen/28.png',
    '9/Loesungen/3.png',
    '9/Loesungen/4.png',
    '9/Loesungen/5.png',
    '9/Loesungen/6.png',
    '9/Loesungen/7.png',
    '9/Loesungen/8.png',
    '9/Loesungen/9.png',
];

class ImageList extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            border: true,
            filter: '',
        };
    }

    render() {
        return (
            <>
                <div style={{position: 'fixed', left: '0px', top: '0px'}}><button onClick={() => this.setState({ border: !this.state.border })} >Toggle borders</button><button title="Beispiele:&#013;Grundwissen&#013;5/Aufgaben" onClick={() => this.setState({ filter: prompt('filter:') })} >Filter</button></div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#e8e9eb' }}>
                    {images.map(name =>
                        name.indexOf(this.state.filter) !== -1 &&
                        <>
                            <div>{name}</div>
                            <img key={name} alt={name} title={name} src={require('../img/' + name)} style={{ maxHeight: '50vh', maxWidth: '100vw', border: '1px ' +  (this.state.border ? 'solid' : 'none') + ' black' }} />
                            <div style={{ height: '2vh', width: '100%', borderBottom: '2px solid #cccdc6' }} />
                            <div style={{ height: '2vh', width: '100%' }} />
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default ImageList;